import { render, staticRenderFns } from "./UiInputText.vue?vue&type=template&id=6f683d6c&scoped=true"
import script from "./UiInputText.vue?vue&type=script&lang=js"
export * from "./UiInputText.vue?vue&type=script&lang=js"
import style0 from "./UiInputText.vue?vue&type=style&index=0&id=6f683d6c&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f683d6c",
  null
  
)

export default component.exports